<template>
  <section class="section solution-carousel-section">
    <div class="solution-shell">
      <div
        class="solution-stage"
        @mousedown="handleDragStart"
        @mousemove="handleDragMove"
        @mouseup="handleDragEnd"
        @mouseleave="handleDragEnd"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
      >
        <article
          v-for="(slide, index) in slides"
          :key="slide.image + index"
          class="solution-slide"
          :class="{ active: index === activeIndex }"
          :style="{ backgroundImage: 'linear-gradient(180deg, rgba(2,18,34,0.36), rgba(2,18,34,0.52)), url(' + slide.image + ')' }"
        >
          <div class="solution-copy" :class="{ active: index === activeIndex }">
            <p class="solution-tag">{{ sectionTag }}</p>
            <h2>{{ $pick(slide.title) }}</h2>
            <span>{{ $pick(slide.description) }}</span>
          </div>

          <div class="solution-back-index" :class="{ active: index === activeIndex }">
            {{ indexNumber(index) }}
          </div>
        </article>
      </div>

      <div class="solution-nav">
        <button
          v-for="(slide, index) in slides"
          :key="'nav-' + index"
          type="button"
          class="solution-index"
          :class="{ active: index === activeIndex }"
          @click="goTo(index)"
        >
          {{ indexNumber(index) }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SolutionCarousel",
  data() {
    return {
      activeIndex: 0,
      dragStartX: 0,
      dragDeltaX: 0,
      isDragging: false,
      timer: null,
      slides: [
        {
          image: "/solutions/solution_img1.jpg",
          title: {
            "zh-CN": "新能源配电解决方案",
            "en-US": "New energy power distribution solutions"
          },
          description: {
            "zh-CN": "适配光伏、风电、储能及分布式能源项目，定制专用配电设备，优化布局，保障输电稳定、安全并网",
            "en-US": "Suitable for photovoltaic, wind power, energy storage and distributed energy projects, we customize dedicated power distribution equipment, optimize layout, and ensure stable power transmission and safe grid connection."
          }
        },
        {
          image: "/solutions/solution_img2.jpg",
          title: {
            "zh-CN": "工商业厂区配电解决方案",
            "en-US": "Power distribution solutions for industrial and commercial plants"
          },
          description: {
            "zh-CN": "服务工厂、园区、商业楼宇，规划高低压配电布局，合理配置负荷，降本降耗，保障连续稳定用电。",
            "en-US": "We serve factories, industrial parks, and commercial buildings, planning high and low voltage power distribution layouts, rationally allocating loads, reducing costs and energy consumption, and ensuring continuous and stable power supply."
          }
        },
        {
          image: "/solutions/solution_img3.jpg",
          title: {
            "zh-CN": "市政与电网改造解决方案",
            "en-US": "Municipal and power grid transformation solutions"
          },
          description: {
            "zh-CN": "承接城乡电网、小区及市政设施配电改造，采用标准模块化配置，施工简便、运行可靠，符合市政长效建设标准。",
            "en-US": "We undertake the renovation of urban and rural power grids, residential communities, and municipal facilities distribution systems. Our systems utilize standardized modular configurations, ensuring simple construction, reliable operation, and compliance with long-term municipal construction standards."
          }
        },
        {
          image: "/solutions/solution_img12.jpg",
          title: {
            "zh-CN": "工矿特种配电解决方案",
            "en-US": "Specialized power distribution solutions for industrial and mining industries"
          },
          description: {
            "zh-CN": "适配矿山、冶金、化工恶劣工况，定制专用配电系统，设备防尘抗压、性能稳定，满足特种行业安全用电规范。",
            "en-US": "Adapted to harsh working conditions in mining, metallurgy, and chemical industries, the equipment features a customized power distribution system, dustproof and pressure-resistant properties, stable performance, and meets the safety electricity use standards of special industries."
          }
        },
        {
          image: "/solutions/solution_img5.jpg",
          title: {
            "zh-CN": "海外工程配电解决方案",
            "en-US": "Overseas Engineering Power Distribution Solutions"
          },
          description: {
            "zh-CN": "遵循各国电气标准，提供方案设计、设备定制、技术对接一站式服务，适配海外基建、工业及电站配套项目。",
            "en-US": "Adhering to electrical standards in various countries, we provide one-stop services including solution design, equipment customization, and technical integration, suitable for overseas infrastructure, industrial, and power plant projects."
          }
        }
      ]
    };
  },
  computed: {
    sectionTag() {
      return this.locale === "zh-CN" ? "行业解决方案" : "INDUSTRY SOLUTIONS";
    }
  },
  mounted() {
    this.startAutoPlay();
  },
  beforeDestroy() {
    window.clearInterval(this.timer);
  },
  methods: {
    startAutoPlay() {
      window.clearInterval(this.timer);
      this.timer = window.setInterval(() => {
        this.nextSlide();
      }, 5200);
    },
    indexNumber(index) {
      return String(index + 1).padStart(2, "0");
    },
    goTo(index) {
      this.activeIndex = index;
      this.startAutoPlay();
    },
    nextSlide() {
      this.activeIndex = (this.activeIndex + 1) % this.slides.length;
      this.startAutoPlay();
    },
    prevSlide() {
      this.activeIndex = (this.activeIndex - 1 + this.slides.length) % this.slides.length;
      this.startAutoPlay();
    },
    handleDragStart(event) {
      this.isDragging = true;
      this.dragStartX = event.clientX;
      this.dragDeltaX = 0;
    },
    handleDragMove(event) {
      if (!this.isDragging) {
        return;
      }
      this.dragDeltaX = event.clientX - this.dragStartX;
    },
    handleDragEnd() {
      if (!this.isDragging) {
        return;
      }

      if (this.dragDeltaX < -70) {
        this.nextSlide();
      } else if (this.dragDeltaX > 70) {
        this.prevSlide();
      } else {
        this.startAutoPlay();
      }

      this.isDragging = false;
      this.dragStartX = 0;
      this.dragDeltaX = 0;
    },
    handleTouchStart(event) {
      if (!event.touches || !event.touches.length) {
        return;
      }
      this.isDragging = true;
      this.dragStartX = event.touches[0].clientX;
      this.dragDeltaX = 0;
    },
    handleTouchMove(event) {
      if (!this.isDragging || !event.touches || !event.touches.length) {
        return;
      }
      this.dragDeltaX = event.touches[0].clientX - this.dragStartX;
    },
    handleTouchEnd() {
      this.handleDragEnd();
    }
  }
};
</script>

<style scoped>
.solution-carousel-section {
  background: #ffffff;
  padding-left: 0;
  padding-right: 0;
}

.solution-shell {
  position: relative;
  width: 100%;
  margin: 0 auto;
}

.solution-stage {
  position: relative;
  height: 780px;
  overflow: hidden;
  cursor: grab;
  user-select: none;
}

.solution-stage:active {
  cursor: grabbing;
}

.solution-slide {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-position: center;
  background-size: cover;
  opacity: 0;
  transform: scale(1.03);
  transition: opacity 0.9s ease, transform 1.1s ease;
}

.solution-slide.active {
  opacity: 1;
  transform: scale(1);
}

.solution-copy {
  position: relative;
  z-index: 2;
  max-width: 980px;
  padding: 0 24px;
  text-align: center;
  color: #ffffff;
  opacity: 0;
  transform: translateY(40px);
}

.solution-copy.active {
  animation: solutionTextIn 1s cubic-bezier(0.2, 0.75, 0.2, 1) 0.18s forwards;
}

.solution-tag {
  margin: 0 0 16px;
  font-size: 14px;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  opacity: 0.9;
}

.solution-copy h2 {
  margin: 0 0 22px;
  font-size: clamp(42px, 4.5vw, 64px);
  line-height: 1.08;
  text-shadow: 0 14px 34px rgba(0, 0, 0, 0.22);
}

.solution-copy span {
  display: block;
  max-width: 44em;
  margin: 0 auto;
  font-size: 18px;
  line-height: 1.8;
  text-shadow: 0 10px 22px rgba(0, 0, 0, 0.18);
}

.solution-back-index {
  position: absolute;
  right: 13%;
  top: 24%;
  z-index: 1;
  color: rgba(255, 255, 255, 0.08);
  font-size: clamp(98px, 12vw, 176px);
  font-weight: 800;
  letter-spacing: 0.04em;
  opacity: 0;
  transform: translateX(50px);
}

.solution-back-index.active {
  animation: solutionImageAccent 1.1s cubic-bezier(0.2, 0.75, 0.2, 1) 0.34s forwards;
}

.solution-nav {
  position: absolute;
  left: 50%;
  bottom: 32px;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 24px;
  transform: translateX(-50%);
}

.solution-nav::before {
  content: "";
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: -10px;
  height: 1px;
  background: rgba(255, 255, 255, 0.24);
}

.solution-index {
  position: relative;
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.84);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.25s ease, transform 0.25s ease;
}

.solution-index.active,
.solution-index:hover {
  color: #ffffff;
  transform: translateY(-2px);
}

.solution-index.active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -14px;
  width: 34px;
  height: 2px;
  background: #ffffff;
  transform: translateX(-50%);
}

@keyframes solutionTextIn {
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes solutionImageAccent {
  from {
    opacity: 0;
    transform: translateX(50px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 900px) {
  .solution-stage {
    height: 560px;
  }

  .solution-copy span {
    font-size: 16px;
  }

  .solution-back-index {
    right: 6%;
    top: 18%;
  }
}

@media (max-width: 520px) {
  .solution-stage {
    height: 460px;
  }

  .solution-copy {
    padding: 0 18px;
  }

  .solution-tag {
    font-size: 12px;
    letter-spacing: 0.16em;
  }

  .solution-copy h2 {
    font-size: 30px;
    line-height: 1.18;
  }

  .solution-copy span {
    font-size: 14px;
    line-height: 1.75;
  }

  .solution-nav {
    gap: 16px;
    bottom: 24px;
  }
}
</style>
